/*!
 * fullPage 4.0.33
 * https://github.com/alvarotrigo/fullPage.js
 *
 * @license GPLv3 for open source use only
 * or Fullpage Commercial License for commercial use
 * http://alvarotrigo.com/fullPage/pricing/
 *
 * Copyright (C) 2018 http://alvarotrigo.com/fullPage - A project by Alvaro Trigo
 */
!(function (n, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((n =
        "undefined" != typeof globalThis ? globalThis : n || self).fullpage =
        t());
})(this, function () {
  "use strict";
  var n, t, e, i;
  Array.prototype.find ||
    Object.defineProperty(Array.prototype, "find", {
      value: function (n) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var t = Object(this),
          e = t.length >>> 0;
        if ("function" != typeof n)
          throw new TypeError("predicate must be a function");
        for (var i = arguments[1], o = 0; o < e; ) {
          var r = t[o];
          if (n.call(i, r, o, t)) return r;
          o++;
        }
      },
    }),
    Array.from ||
      (Array.from =
        ((n = Object.prototype.toString),
        (t = function (t) {
          return "function" == typeof t || "[object Function]" === n.call(t);
        }),
        (e = Math.pow(2, 53) - 1),
        (i = function (n) {
          var t = (function (n) {
            var t = Number(n);
            return isNaN(t)
              ? 0
              : 0 !== t && isFinite(t)
              ? (t > 0 ? 1 : -1) * Math.floor(Math.abs(t))
              : t;
          })(n);
          return Math.min(Math.max(t, 0), e);
        }),
        function (n) {
          var e = this,
            o = Object(n);
          if (null == n)
            throw new TypeError(
              "Array.from requires an array-like object - not null or undefined"
            );
          var r,
            a = arguments.length > 1 ? arguments[1] : void 0;
          if (void 0 !== a) {
            if (!t(a))
              throw new TypeError(
                "Array.from: when provided, the second argument must be a function"
              );
            arguments.length > 2 && (r = arguments[2]);
          }
          for (
            var u,
              l = i(o.length),
              c = t(e) ? Object(new e(l)) : new Array(l),
              f = 0;
            f < l;

          )
            (u = o[f]),
              (c[f] = a ? (void 0 === r ? a(u, f) : a.call(r, u, f)) : u),
              (f += 1);
          return (c.length = l), c;
        }));
  var o,
    r = window,
    a = document,
    u =
      navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/
      ) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document),
    l = /(Mac|iPhone|iPod|iPad)/i.test(r.navigator.userAgent),
    c =
      "ontouchstart" in r ||
      navigator.msMaxTouchPoints > 0 ||
      navigator.maxTouchPoints,
    f = !!window.MSInputMethodContext && !!document.documentMode,
    s = { test: {}, shared: {} },
    v = [
      "parallax",
      "scrollOverflowReset",
      "dragAndMove",
      "offsetSections",
      "fadingEffect",
      "responsiveSlides",
      "continuousHorizontal",
      "interlockedSlides",
      "scrollHorizontally",
      "resetSliders",
      "cards",
      "dropEffect",
      "waterEffect",
    ],
    d =
      ((o = window.self !== window.top),
      function () {
        return o;
      });
  function h(n, t) {
    r.console && r.console[n] && r.console[n]("fullPage: " + t);
  }
  function p(n) {
    return "none" !== r.getComputedStyle(n).display;
  }
  function g(n) {
    return Array.from(n).filter(function (n) {
      return p(n);
    });
  }
  function m(n, t) {
    return (t = arguments.length > 1 ? t : document)
      ? t.querySelectorAll(n)
      : null;
  }
  function w(n) {
    n = n || {};
    for (var t = 1, e = arguments.length; t < e; ++t) {
      var i = arguments[t];
      if (i)
        for (var o in i)
          i.hasOwnProperty(o) &&
            "__proto__" != o &&
            "constructor" != o &&
            ("[object Object]" !== Object.prototype.toString.call(i[o])
              ? (n[o] = i[o])
              : (n[o] = w(n[o], i[o])));
    }
    return n;
  }
  function b(n, t) {
    return null != n && n.classList.contains(t);
  }
  function y() {
    return "innerHeight" in r ? r.innerHeight : a.documentElement.offsetHeight;
  }
  function S() {
    return r.innerWidth;
  }
  function T(n, t) {
    var e;
    for (e in ((n = O(n)), t))
      if (t.hasOwnProperty(e) && null !== e)
        for (var i = 0; i < n.length; i++) n[i].style[e] = t[e];
    return n;
  }
  function M(n) {
    return n.previousElementSibling;
  }
  function A(n) {
    return n.nextElementSibling;
  }
  function x(n) {
    return n[n.length - 1];
  }
  function k(n, t) {
    n = D(n) ? n[0] : n;
    for (
      var e = null != t ? m(t, n.parentNode) : n.parentNode.childNodes,
        i = 0,
        o = 0;
      o < e.length;
      o++
    ) {
      if (e[o] == n) return i;
      1 == e[o].nodeType && i++;
    }
    return -1;
  }
  function O(n) {
    return D(n) ? n : [n];
  }
  function j(n) {
    n = O(n);
    for (var t = 0; t < n.length; t++) n[t].style.display = "none";
    return n;
  }
  function L(n) {
    n = O(n);
    for (var t = 0; t < n.length; t++) n[t].style.display = "block";
    return n;
  }
  function D(n) {
    return (
      "[object Array]" === Object.prototype.toString.call(n) ||
      "[object NodeList]" === Object.prototype.toString.call(n)
    );
  }
  function E(n, t) {
    n = O(n);
    for (var e = 0; e < n.length; e++) n[e].classList.add(t);
    return n;
  }
  function R(n, t) {
    n = O(n);
    for (var e = t.split(" "), i = 0; i < e.length; i++) {
      t = e[i];
      for (var o = 0; o < n.length; o++) n[o].classList.remove(t);
    }
    return n;
  }
  function P(n, t) {
    t.appendChild(n);
  }
  function F(n, t, e) {
    var i;
    t = t || a.createElement("div");
    for (var o = 0; o < n.length; o++) {
      var r = n[o];
      ((e && !o) || !e) &&
        ((i = t.cloneNode(!0)), r.parentNode.insertBefore(i, r)),
        i.appendChild(r);
    }
    return n;
  }
  function z(n, t) {
    F(n, t, !0);
  }
  function C(n, t) {
    for (n.appendChild(t); n.firstChild !== t; ) t.appendChild(n.firstChild);
  }
  function I(n) {
    for (var t = a.createDocumentFragment(); n.firstChild; )
      t.appendChild(n.firstChild);
    n.parentNode.replaceChild(t, n);
  }
  function N(n, t) {
    return n && 1 === n.nodeType ? (J(n, t) ? n : N(n.parentNode, t)) : null;
  }
  function B(n, t) {
    W(n, n.nextSibling, t);
  }
  function H(n, t) {
    W(n, n, t);
  }
  function W(n, t, e) {
    D(e) || ("string" == typeof e && (e = nn(e)), (e = [e]));
    for (var i = 0; i < e.length; i++) n.parentNode.insertBefore(e[i], t);
  }
  function V() {
    var n = a.documentElement;
    return (r.pageYOffset || n.scrollTop) - (n.clientTop || 0);
  }
  function U(n) {
    return Array.prototype.filter.call(n.parentNode.children, function (t) {
      return t !== n;
    });
  }
  function _(n) {
    n.preventDefault();
  }
  function K(n, t) {
    return n.getAttribute(t);
  }
  function q(n, t, e) {
    a.addEventListener(n, t, "undefined" === e ? null : e);
  }
  function G(n, t, e) {
    r.addEventListener(n, t, "undefined" === e ? null : e);
  }
  function $(n, t, e) {
    a.removeEventListener(n, t, "undefined" === e ? null : e);
  }
  function Y(n, t, e) {
    r.removeEventListener(n, t, "undefined" === e ? null : e);
  }
  function X(n) {
    if ("function" == typeof n) return !0;
    var t = Object.prototype.toString.call(n);
    return "[object Function]" === t || "[object GeneratorFunction]" === t;
  }
  function Q(n, t, e) {
    var i;
    (e = void 0 === e ? {} : e),
      "function" == typeof r.CustomEvent
        ? (i = new CustomEvent(t, { detail: e }))
        : (i = a.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, e),
      n.dispatchEvent(i);
  }
  function J(n, t) {
    return (
      n.matches ||
      n.t ||
      n.msMatchesSelector ||
      n.mozMatchesSelector ||
      n.webkitMatchesSelector ||
      n.oMatchesSelector
    ).call(n, t);
  }
  function Z(n, t) {
    if ("boolean" == typeof t)
      for (var e = 0; e < n.length; e++)
        n[e].style.display = t ? "block" : "none";
    return n;
  }
  function nn(n) {
    var t = a.createElement("div");
    return (t.innerHTML = n.trim()), t.firstChild;
  }
  function tn(n) {
    n = O(n);
    for (var t = 0; t < n.length; t++) {
      var e = n[t];
      e && e.parentElement && e.parentNode.removeChild(e);
    }
  }
  function en(n, t, e) {
    for (var i = n[e], o = []; i; )
      (J(i, t) || null == t) && o.push(i), (i = i[e]);
    return o;
  }
  function on(n, t) {
    return en(n, t, "nextElementSibling");
  }
  function rn(n, t) {
    return en(n, t, "previousElementSibling");
  }
  function an(n) {
    return Object.keys(n).map(function (t) {
      return n[t];
    });
  }
  function un(n) {
    return n[n.length - 1];
  }
  function ln(n, t) {
    for (
      var e = 0, i = n.slice(Math.max(n.length - t, 1)), o = 0;
      o < i.length;
      o++
    )
      e += i[o];
    return Math.ceil(e / t);
  }
  function cn(n, t) {
    n.setAttribute(t, K(n, "data-" + t)), n.removeAttribute("data-" + t);
  }
  function fn(n, t) {
    var e = [n];
    do {
      (n = n.parentNode), e.push(n);
    } while (!J(n, t));
    return e;
  }
  function sn() {
    var n = a.activeElement;
    return (
      J(n, "textarea") ||
      J(n, "input") ||
      J(n, "select") ||
      "true" == K(n, "contentEditable") ||
      "" == K(n, "contentEditable")
    );
  }
  r.NodeList &&
    !NodeList.prototype.forEach &&
    (NodeList.prototype.forEach = function (n, t) {
      t = t || window;
      for (var e = 0; e < this.length; e++) n.call(t, this[e], e, this);
    }),
    "function" != typeof Object.assign &&
      Object.defineProperty(Object, "assign", {
        value: function (n, t) {
          if (null == n)
            throw new TypeError("Cannot convert undefined or null to object");
          for (var e = Object(n), i = 1; i < arguments.length; i++) {
            var o = arguments[i];
            if (null != o)
              for (var r in o)
                Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
          }
          return e;
        },
        writable: !0,
        i: !0,
      }),
    String.prototype.padStart ||
      (String.prototype.padStart = function (n, t) {
        return (
          (n >>= 0),
          (t = String(void 0 !== t ? t : " ")),
          this.length > n
            ? String(this)
            : ((n -= this.length) > t.length &&
                (t += Array.apply(null, Array(n))
                  .map(function () {
                    return t;
                  })
                  .join("")),
              t.slice(0, n) + String(this))
        );
      }),
    (window.fp_utils = {
      $: m,
      deepExtend: w,
      hasClass: b,
      getWindowHeight: y,
      css: T,
      prev: M,
      next: A,
      last: x,
      index: k,
      getList: O,
      hide: j,
      show: L,
      isArrayOrList: D,
      addClass: E,
      removeClass: R,
      appendTo: P,
      wrap: F,
      wrapAll: z,
      unwrap: I,
      closest: N,
      after: B,
      before: H,
      insertBefore: W,
      getScrollTop: V,
      siblings: U,
      preventDefault: _,
      isFunction: X,
      trigger: Q,
      matches: J,
      toggle: Z,
      createElementFromHTML: nn,
      remove: tn,
      untilAll: en,
      nextAll: on,
      prevAll: rn,
      showError: h,
    });
  var vn = Object.freeze({
    __proto__: null,
    showError: h,
    isVisible: p,
    o: g,
    $: m,
    deepExtend: w,
    hasClass: b,
    getWindowHeight: y,
    u: S,
    css: T,
    prev: M,
    next: A,
    last: x,
    index: k,
    getList: O,
    hide: j,
    show: L,
    isArrayOrList: D,
    addClass: E,
    removeClass: R,
    appendTo: P,
    wrap: F,
    wrapAll: z,
    l: C,
    unwrap: I,
    closest: N,
    after: B,
    before: H,
    insertBefore: W,
    getScrollTop: V,
    siblings: U,
    preventDefault: _,
    v: K,
    h: q,
    p: G,
    g: $,
    S: Y,
    isFunction: X,
    trigger: Q,
    matches: J,
    toggle: Z,
    createElementFromHTML: nn,
    remove: tn,
    untilAll: en,
    nextAll: on,
    prevAll: rn,
    toArray: an,
    T: un,
    M: ln,
    A: cn,
    O: fn,
    j: sn,
  });
  function dn(n) {
    return (
      (dn =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (n) {
              return typeof n;
            }
          : function (n) {
              return n &&
                "function" == typeof Symbol &&
                n.constructor === Symbol &&
                n !== Symbol.prototype
                ? "symbol"
                : typeof n;
            }),
      dn(n)
    );
  }
  var hn = {
      L: {},
      D: function (n, t) {
        var e = this;
        return (
          "object" !== dn(this.L[n]) && (this.L[n] = []),
          this.L[n].push(t),
          function () {
            return e.removeListener(n, t);
          }
        );
      },
      removeListener: function (n, t) {
        if ("object" === dn(this.L[n])) {
          var e = this.L[n].indexOf(t);
          e > -1 && this.L[n].splice(e, 1);
        }
      },
      R: function (n) {
        for (
          var t = this,
            e = arguments.length,
            i = new Array(e > 1 ? e - 1 : 0),
            o = 1;
          o < e;
          o++
        )
          i[o - 1] = arguments[o];
        "object" === dn(this.L[n]) &&
          this.L[n].forEach(function (n) {
            return n.apply(t, i);
          });
      },
      once: function (n, t) {
        var e = this,
          i = this.D(n, function () {
            i();
            for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
              o[r] = arguments[r];
            t.apply(e, o);
          });
      },
    },
    pn = {
      P: 0,
      F: 0,
      slides: [],
      C: [],
      I: null,
      N: null,
      B: !1,
      H: !1,
      W: !1,
      V: !1,
      U: !1,
      _: void 0,
      K: void 0,
      q: !1,
      G: !0,
      Y: "none",
      X: "none",
      J: !1,
      Z: !1,
      nn: !0,
      tn: 0,
      en: y(),
      on: !1,
      rn: {},
      scrollY: 0,
      scrollX: 0,
      an: !1,
    };
  function gn(n) {
    Object.assign(pn, n);
  }
  function mn() {
    return pn;
  }
  r.state = pn;
  var wn = "onAfterRenderNoAnchor",
    bn = "onClickOrTouch",
    yn = "moveSlideLeft",
    Sn = "moveSlideRight",
    Tn = "onInitialise",
    Mn = "beforeInit",
    An = "bindEvents",
    xn = "onDestroy",
    kn = "contentChanged",
    On = "onScrollOverflowScrolled",
    jn = "onScrollPageAndSlide",
    Ln = "onKeyDown",
    Dn = "onMenuClick",
    En = "scrollPage",
    Rn = "landscapeScroll",
    Pn = "scrollBeyondFullpage",
    Fn = "onPerformMovement",
    zn = "onSlideLeave",
    Cn = "onLeave",
    In = "afterSectionLoads",
    Nn = "afterSlideLoads";
  function Bn(n) {
    hn.R(bn, { e: n, target: n.target });
  }
  function Hn() {
    ["click", "touchstart"].forEach(function (n) {
      $(n, Bn);
    });
  }
  function Wn() {
    gn({ nn: !0 });
  }
  hn.D(An, function () {
    ["click", "touchstart"].forEach(function (n) {
      q(n, Bn);
    }),
      G("focus", Wn),
      hn.D(xn, Hn);
  });
  var Vn = "fullpage-wrapper",
    Un = "." + Vn,
    _n = "fp-scrollable",
    Kn = "fp-responsive",
    qn = "fp-notransition",
    Gn = "fp-destroyed",
    $n = "fp-enabled",
    Yn = "active",
    Xn = ".active",
    Qn = "fp-completely",
    Jn = "fp-section",
    Zn = "." + Jn,
    nt = ".fp-tableCell",
    tt = "#fp-nav",
    et = "fp-slide",
    it = "." + et,
    ot = ".fp-slide.active",
    rt = "fp-slides",
    at = ".fp-slides",
    ut = "fp-slidesContainer",
    lt = "." + ut,
    ct = "fp-table",
    ft = "fp-overflow",
    st = "." + ft,
    vt = "fp-is-overflow",
    dt = ".fp-slidesNav",
    ht = ".fp-slidesNav a",
    pt = "fp-controlArrow",
    gt = "." + pt,
    mt = "fp-prev",
    wt = ".fp-controlArrow.fp-prev",
    bt = ".fp-controlArrow.fp-next",
    yt = {
      menu: !1,
      anchors: [],
      lockAnchors: !1,
      navigation: !1,
      navigationPosition: "right",
      navigationTooltips: [],
      showActiveTooltip: !1,
      slidesNavigation: !1,
      slidesNavPosition: "bottom",
      scrollBar: !1,
      hybrid: !1,
      licenseKey: "",
      credits: {
        enabled: !0,
        label: "Made with fullPage.js",
        position: "right",
      },
      css3: !0,
      scrollingSpeed: 700,
      autoScrolling: !0,
      fitToSection: !0,
      fitToSectionDelay: 600,
      easing: "easeInOutCubic",
      easingcss3: "ease",
      loopBottom: !1,
      loopTop: !1,
      loopHorizontal: !0,
      continuousVertical: !1,
      continuousHorizontal: !1,
      scrollHorizontally: !1,
      interlockedSlides: !1,
      dragAndMove: !1,
      offsetSections: !1,
      resetSliders: !1,
      fadingEffect: !1,
      normalScrollElements: null,
      scrollOverflow: !0,
      scrollOverflowReset: !1,
      skipIntermediateItems: !1,
      touchSensitivity: 5,
      touchWrapper: null,
      bigSectionsDestination: null,
      adjustOnNavChange: !0,
      keyboardScrolling: !0,
      animateAnchor: !0,
      recordHistory: !0,
      allowCorrectDirection: !1,
      scrollOverflowMacStyle: !0,
      controlArrows: !0,
      controlArrowsHTML: [
        '<div class="fp-arrow"></div>',
        '<div class="fp-arrow"></div>',
      ],
      controlArrowColor: "#fff",
      verticalCentered: !0,
      sectionsColor: [],
      paddingTop: 0,
      paddingBottom: 0,
      fixedElements: null,
      responsive: 0,
      responsiveWidth: 0,
      responsiveHeight: 0,
      responsiveSlides: !1,
      parallax: !1,
      parallaxOptions: {
        type: "reveal",
        percentage: 62,
        property: "translate",
      },
      cards: !1,
      cardsOptions: { perspective: 100, fadeContent: !0, fadeBackground: !0 },
      sectionSelector: ".section",
      slideSelector: ".slide",
      afterLoad: null,
      beforeLeave: null,
      onLeave: null,
      afterRender: null,
      afterResize: null,
      afterReBuild: null,
      afterSlideLoad: null,
      onSlideLeave: null,
      afterResponsive: null,
      onScrollOverflow: null,
      lazyLoading: !0,
      lazyLoadThreshold: 0,
      observer: !0,
      scrollBeyondFullpage: !0,
    },
    St = null,
    Tt = !1,
    Mt = w({}, yt),
    At = null;
  function xt(n) {
    return St;
  }
  function kt() {
    return At || yt;
  }
  function Ot() {
    return Mt;
  }
  function jt(n, t, e) {
    (At[n] = t), "internal" !== e && (Mt[n] = t);
  }
  function Lt() {
    if (!kt().anchors.length) {
      var n = m(
        kt().sectionSelector.split(",").join("[data-anchor],") +
          "[data-anchor]",
        St
      );
      n.length &&
        n.length === m(kt().sectionSelector, St).length &&
        ((Tt = !0),
        n.forEach(function (n) {
          kt().anchors.push(K(n, "data-anchor").toString());
        }));
    }
    if (!kt().navigationTooltips.length) {
      var t = m(
        kt().sectionSelector.split(",").join("[data-tooltip],") +
          "[data-tooltip]",
        St
      );
      t.length &&
        t.forEach(function (n) {
          kt().navigationTooltips.push(K(n, "data-tooltip").toString());
        });
    }
  }
  var Dt = function (n) {
      (this.anchor = n.anchor),
        (this.item = n.item),
        (this.index = n.index()),
        (this.isLast =
          this.index ===
          n.item.parentElement.querySelectorAll(n.selector).length - 1),
        (this.isFirst = !this.index),
        (this.isActive = n.isActive);
    },
    Et = function (n, t) {
      (this.parent = this.parent || null),
        (this.selector = t),
        (this.anchor =
          K(n, "data-anchor") || kt().anchors[k(n, kt().sectionSelector)]),
        (this.item = n),
        (this.isVisible = p(n)),
        (this.isActive = b(n, Yn)),
        (this.un = b(n, ft) || null != m(st, n)[0]),
        (this.ln = t === kt().sectionSelector),
        (this.cn = N(n, lt) || N(n, Un)),
        (this.index = function () {
          return this.siblings().indexOf(this);
        });
    };
  function Rt(n) {
    return n.map(function (n) {
      return n.item;
    });
  }
  function Pt(n, t) {
    return n.find(function (n) {
      return n.item === t;
    });
  }
  (Et.prototype.siblings = function () {
    return this.ln
      ? this.isVisible
        ? pn.C
        : pn.sn
      : this.parent
      ? this.parent.slides
      : 0;
  }),
    (Et.prototype.prev = function () {
      var n = this.siblings(),
        t = (this.ln ? n.indexOf(this) : this.parent.slides.indexOf(this)) - 1;
      return t >= 0 ? n[t] : null;
    }),
    (Et.prototype.next = function () {
      var n = this.siblings(),
        t = (this.ln ? n.indexOf(this) : this.parent.slides.indexOf(this)) + 1;
      return t < n.length ? n[t] : null;
    }),
    (Et.prototype.prevPanel = function () {
      return this.prev() || (this.parent ? this.parent.prev() : null);
    }),
    (Et.prototype.nextPanel = function () {
      return this.next() || (this.parent ? this.parent.next() : null);
    }),
    (Et.prototype.vn = function () {
      return this.ln ? pn.C : pn.dn;
    });
  var Ft,
    zt = function (n) {
      Dt.call(this, n);
    },
    Ct = function (n) {
      Dt.call(this, n);
    };
  function It(n) {
    var t = m(ot, n);
    return t.length && (n = t[0]), n;
  }
  function Nt(n) {
    return n ? (n.activeSlide ? n.activeSlide : n) : null;
  }
  function Bt(n) {
    var t,
      e,
      i = kt();
    return (
      i.autoScrolling && !i.scrollBar
        ? ((t = -n), (e = m(Un)[0]))
        : ((t = n), (e = window)),
      { options: t, element: e }
    );
  }
  function Ht(n, t) {
    !kt().autoScrolling || kt().scrollBar || (n.self != window && b(n, rt))
      ? n.self != window && b(n, rt)
        ? (n.scrollLeft = t)
        : n.scrollTo(0, t)
      : (n.style.top = t + "px");
  }
  function Wt(n) {
    var t = "transform " + kt().scrollingSpeed + "ms " + kt().easingcss3;
    return R(n, qn), T(n, { "-webkit-transition": t, transition: t });
  }
  function Vt(n, t) {
    var e = n.index(),
      i = k(t, Zn);
    return e == i ? "none" : e > i ? "up" : "down";
  }
  function Ut(n) {
    return E(n, qn);
  }
  function _t(n) {
    return {
      "-webkit-transform": n,
      "-moz-transform": n,
      "-ms-transform": n,
      transform: n,
    };
  }
  function Kt(n, t) {
    t ? Wt(xt()) : Ut(xt()),
      clearTimeout(Ft),
      T(xt(), _t(n)),
      (s.test.hn = n),
      (Ft = setTimeout(function () {
        R(xt(), qn);
      }, 10));
  }
  function qt(n) {
    var t = Math.round(n);
    if (kt().css3 && kt().autoScrolling && !kt().scrollBar)
      Kt("translate3d(0px, -" + t + "px, 0px)", !1);
    else if (kt().autoScrolling && !kt().scrollBar)
      T(xt(), { top: -t + "px" }), (s.test.top = -t + "px");
    else {
      var e = Bt(t);
      Ht(e.element, e.options);
    }
  }
  function Gt(n, t) {
    jt("scrollingSpeed", n, t);
  }
  s.setScrollingSpeed = Gt;
  var $t,
    Yt = null,
    Xt = null,
    Qt = null;
  function Jt(n, t, e, i) {
    var o,
      a = (function (n) {
        return n.self != r && b(n, rt)
          ? n.scrollLeft
          : !kt().autoScrolling || kt().scrollBar
          ? V()
          : n.offsetTop;
      })(n),
      u = t - a,
      l = !1,
      c = pn.q;
    gn({ q: !0 }),
      $t && window.cancelAnimationFrame($t),
      ($t = function (f) {
        o || (o = f);
        var s = Math.floor(f - o);
        if (pn.q) {
          var v = t;
          e && (v = r.fp_easings[kt().easing](s, a, u, e)),
            s <= e && Ht(n, v),
            s < e
              ? window.requestAnimationFrame($t)
              : void 0 === i || l || (i(), gn({ q: !1 }), (l = !0));
        } else l || c || (i(), gn({ q: !1 }), (l = !0));
      }),
      window.requestAnimationFrame($t);
  }
  function Zt(n) {
    return n && !n.item ? new zt(new ui(n)) : n ? new zt(n) : null;
  }
  function ne(n) {
    return n ? new Ct(n) : null;
  }
  function te(n, t) {
    var e = (function (n, t) {
      var e = {
        afterRender: function () {
          return { section: Zt(mn().I), pn: ne(mn().I.activeSlide) };
        },
        onLeave: function () {
          return {
            origin: Zt(t.items.origin),
            destination: Zt(t.items.destination),
            direction: t.direction,
            trigger: mn().N,
          };
        },
        afterLoad: function () {
          return e.onLeave();
        },
        afterSlideLoad: function () {
          return {
            section: Zt(t.items.section),
            origin: Zt(t.items.origin),
            destination: Zt(t.items.destination),
            direction: t.direction,
            trigger: mn().N,
          };
        },
        onSlideLeave: function () {
          return e.afterSlideLoad();
        },
        beforeLeave: function () {
          return e.onLeave();
        },
        onScrollOverflow: function () {
          return {
            section: Zt(mn().I),
            pn: ne(mn().I.activeSlide),
            position: t.position,
            direction: t.direction,
          };
        },
      };
      return e[n]();
    })(n, t);
    return Q(xt(), n, e), !1 !== kt()[n].apply(e[Object.keys(e)[0]], an(e));
  }
  function ee(n) {
    return n.hasAttribute("data-autoplay") || n.hasAttribute("autoplay");
  }
  function ie(n) {
    var t = It(n);
    m("video, audio", t).forEach(function (n) {
      ee(n) && "function" == typeof n.play && n.play();
    }),
      m('iframe[src*="youtube.com/embed/"]', t).forEach(function (n) {
        ee(n) && oe(n),
          (n.onload = function () {
            ee(n) && oe(n);
          });
      });
  }
  function oe(n) {
    n.contentWindow.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      "*"
    );
  }
  function re(n) {
    var t = It(n);
    m("video, audio", t).forEach(function (n) {
      n.hasAttribute("data-keepplaying") ||
        "function" != typeof n.pause ||
        n.pause();
    }),
      m('iframe[src*="youtube.com/embed/"]', t).forEach(function (n) {
        /youtube\.com\/embed\//.test(K(n, "src")) &&
          !n.hasAttribute("data-keepplaying") &&
          n.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
      });
  }
  function ae(n) {
    kt().lazyLoading &&
      m(
        "img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]",
        It(n)
      ).forEach(function (n) {
        if (
          (["src", "srcset"].forEach(function (t) {
            var e = K(n, "data-" + t);
            null != e &&
              e &&
              (cn(n, t), n.addEventListener("load", function () {}));
          }),
          J(n, "source"))
        ) {
          var t = N(n, "video, audio");
          t && (t.load(), (t.onloadeddata = function () {}));
        }
      });
  }
  function ue(n) {
    var t = kt().lazyLoadThreshold;
    ae(n.item), t && (le(n, "prev", t), le(n, "next", t));
  }
  function le(n, t, e) {
    for (var i = n, o = 0; o < e && (i = i[t]()); o++) ae(i.item);
  }
  function ce() {
    var n = mn().I.item,
      t = mn().I.activeSlide,
      e = fe(n),
      i = String(e);
    t && (i = i + "-" + fe(t.item)),
      (i = i.replace("/", "-").replace("#", "").replace(/\s/g, ""));
    var o = new RegExp("\\b\\s?fp-viewing-[^\\s]+\\b", "g");
    (Yt.className = Yt.className.replace(o, "")), E(Yt, "fp-viewing-" + i);
  }
  function fe(n) {
    if (!n) return null;
    var t = K(n, "data-anchor"),
      e = k(n);
    return null == t && (t = e), t;
  }
  function se(n, t, e) {
    var i = "";
    kt().anchors.length &&
      !kt().lockAnchors &&
      (n
        ? (null != e && (i = e),
          null == t && (t = n),
          gn({ K: t }),
          ve(i + "/" + t))
        : null != n
        ? (gn({ K: t }), ve(e))
        : ve(e)),
      ce();
  }
  function ve(n) {
    if (kt().recordHistory) location.hash = n;
    else if (u || c) r.history.replaceState(void 0, void 0, "#" + n);
    else {
      var t = r.location.href.split("#")[0];
      r.location.replace(t + "#" + n);
    }
  }
  function de(n, t, e) {
    var i = "Section" === t ? kt().anchors[n] : K(e, "data-anchor");
    return encodeURI(kt().navigationTooltips[n] || i || t + " " + (n + 1));
  }
  function he(n) {
    n.cancelable && _(n), gn({ N: "horizontalNav" });
    var t = N(this, Zn),
      e = m(at, N(this, Zn))[0],
      i = Pt(mn().C, t).slides[k(N(this, "li"))];
    hn.R(Rn, { slides: e, destination: i.item });
  }
  var pe = {};
  function ge(n, t, e) {
    "all" !== t
      ? (pe[e][t] = n)
      : Object.keys(pe[e]).forEach(function (t) {
          pe[e][t] = n;
        });
  }
  function me() {
    return pe;
  }
  function we() {
    var n = N(this, Zn);
    b(this, mt) || N(this, mt)
      ? me().m.left && (gn({ N: "slideArrow" }), hn.R(yn, { section: n }))
      : me().m.right && (gn({ N: "slideArrow" }), hn.R(Sn, { section: n }));
  }
  function be(n, t) {
    jt("recordHistory", n, t);
  }
  function ye(n, t) {
    n || qt(0), jt("autoScrolling", n, t);
    var e = mn().I.item;
    if (kt().autoScrolling && !kt().scrollBar)
      T(Qt, { overflow: "hidden", height: "100%" }),
        R(Yt, _n),
        be(Ot().recordHistory, "internal"),
        T(xt(), { "-ms-touch-action": "none", "touch-action": "none" }),
        null != e && qt(e.offsetTop);
    else if (
      (T(Qt, { overflow: "visible", height: "initial" }),
      E(Yt, _n),
      be(!!kt().autoScrolling && Ot().recordHistory, "internal"),
      T(xt(), { "-ms-touch-action": "", "touch-action": "" }),
      null != e)
    ) {
      var i = Bt(e.offsetTop);
      i.element.scrollTo(0, i.options);
    }
  }
  function Se() {
    var n =
      m(".fp-auto-height")[0] || (He() && m(".fp-auto-height-responsive")[0]);
    kt().lazyLoading &&
      n &&
      m(".fp-section:not(.active)").forEach(function (n) {
        var t, e, i, o, r;
        (e = (t = n.getBoundingClientRect()).top),
          (i = t.bottom),
          (o = e + 2 < pn.en && e > 0),
          (r = i > 2 && i < pn.en),
          (o || r) && ue(Pt(mn().C, n));
      });
  }
  function Te() {
    Q(M(this), "click");
  }
  function Me() {
    tn(m(tt));
    var n = a.createElement("div");
    n.setAttribute("id", "fp-nav");
    var t = a.createElement("ul");
    n.appendChild(t), P(n, Yt);
    var e = m(tt)[0];
    E(e, "fp-" + kt().navigationPosition),
      kt().showActiveTooltip && E(e, "fp-show-active");
    for (var i = "", o = 0; o < mn().C.length; o++) {
      var r = mn().C[o],
        u = "";
      kt().anchors.length && (u = r.anchor),
        (i +=
          '<li><a href="#' +
          encodeURI(u) +
          '"><span class="fp-sr-only">' +
          de(r.index(), "Section") +
          "</span><span></span></a>");
      var l = kt().navigationTooltips[r.index()];
      void 0 !== l &&
        "" !== l &&
        (i +=
          '<div class="fp-tooltip fp-' +
          kt().navigationPosition +
          '">' +
          l +
          "</div>"),
        (i += "</li>");
    }
    m("ul", e)[0].innerHTML = i;
    var c = m("li", m(tt)[0])[mn().I.index()];
    E(m("a", c), Yn);
  }
  function Ae(n) {
    n.preventDefault && _(n), gn({ N: "verticalNav" });
    var t = k(N(this, "#fp-nav li"));
    hn.R(En, { destination: mn().C[t] });
  }
  function xe(n, t) {
    var e;
    (e = n),
      kt().menu &&
        kt().menu.length &&
        m(kt().menu).forEach(function (n) {
          null != n &&
            (R(m(Xn, n), Yn), E(m('[data-menuanchor="' + e + '"]', n), Yn));
        }),
      (function (n, t) {
        var e = m(tt)[0];
        kt().navigation &&
          null != e &&
          "none" !== e.style.display &&
          (R(m(Xn, e), Yn),
          E(n ? m('a[href="#' + n + '"]', e) : m("a", m("li", e)[t]), Yn));
      })(n, t);
  }
  (pe.m = { up: !0, down: !0, left: !0, right: !0 }),
    (pe.k = w({}, pe.m)),
    hn.D(bn, function (n) {
      var t = n.target;
      (J(t, gt) || N(t, gt)) && we.call(t, n);
    }),
    (s.setRecordHistory = be),
    (s.setAutoScrolling = ye),
    (s.test.setAutoScrolling = ye),
    new Date().getTime();
  var ke,
    Oe,
    je,
    Le,
    De,
    Ee,
    Re =
      ((Oe = !0),
      (je = new Date().getTime()),
      (Le = !r.fullpage_api),
      function (n, t) {
        var e = new Date().getTime(),
          i = "wheel" === n ? kt().scrollingSpeed : 100;
        return (
          (Oe = Le || e - je >= i),
          (Le = !r.fullpage_api),
          Oe && ((ke = t()), (je = e)),
          void 0 === ke || ke
        );
      });
  function Pe(n, t) {
    if (X(kt().beforeLeave))
      return Re(mn().N, function () {
        return te(n, t);
      });
  }
  function Fe(n, t, e) {
    var i = n.item;
    if (null != i) {
      var o,
        r,
        a = (function (n) {
          var t = n.offsetHeight,
            e = n.offsetTop,
            i = e,
            o = e > pn.tn,
            r = i - y() + t,
            a = kt().bigSectionsDestination;
          return (
            t > y()
              ? ((o || a) && "bottom" !== a) || (i = r)
              : (o || (pn.V && null == A(n))) && (i = r),
            gn({ tn: i }),
            i
          );
        })(i),
        u = {
          element: i,
          callback: t,
          isMovementUp: e,
          dtop: a,
          yMovement: Vt(mn().I, i),
          anchorLink: n.anchor,
          sectionIndex: n.index(),
          activeSlide: n.activeSlide ? n.activeSlide.item : null,
          leavingSection: mn().I.index() + 1,
          localIsResizing: pn.V,
          items: { origin: mn().I, destination: n },
          direction: null,
        };
      if (
        !(
          (mn().I.item == i && !pn.V) ||
          (kt().scrollBar && V() === u.dtop && !b(i, "fp-auto-height"))
        )
      ) {
        if (
          (null != u.activeSlide &&
            ((o = K(u.activeSlide, "data-anchor")),
            (r = k(u.activeSlide, null))),
          !u.localIsResizing)
        ) {
          var l = u.yMovement;
          if (
            (void 0 !== e && (l = e ? "up" : "down"),
            (u.direction = l),
            X(kt().beforeLeave) && !1 === Pe("beforeLeave", u))
          )
            return;
          if (X(kt().onLeave) && !te("onLeave", u)) return;
        }
        kt().autoScrolling &&
          kt().continuousVertical &&
          void 0 !== u.isMovementUp &&
          ((!u.isMovementUp && "up" == u.yMovement) ||
            (u.isMovementUp && "down" == u.yMovement)) &&
          (u = (function (n) {
            gn({ on: !0 });
            var t = mn().I.item;
            return (
              n.isMovementUp ? H(t, on(t, Zn)) : B(t, rn(t, Zn).reverse()),
              qt(mn().I.item.offsetTop),
              (function () {
                for (var n = m(ot), t = 0; t < n.length; t++)
                  ni(n[t], "internal");
              })(),
              (n.gn = t),
              (n.dtop = n.element.offsetTop),
              (n.yMovement = Vt(mn().I, n.element)),
              n
            );
          })(u)),
          u.localIsResizing || re(mn().I.item),
          E(i, Yn),
          R(U(i), Yn),
          ii(),
          ue(n),
          gn({ G: s.test.mn }),
          se(r, o, u.anchorLink),
          hn.R(Cn, u),
          (function (n) {
            gn({ Y: "none", scrollY: Math.round(n.dtop) }), hn.R(Fn, n);
            var t = kt().scrollingSpeed < 700,
              e = t ? 700 : kt().scrollingSpeed;
            if (kt().css3 && kt().autoScrolling && !kt().scrollBar)
              Kt("translate3d(0px, -" + Math.round(n.dtop) + "px, 0px)", !0),
                kt().scrollingSpeed
                  ? (clearTimeout(De),
                    (De = setTimeout(function () {
                      ze(n), gn({ G: !t || s.test.mn });
                    }, kt().scrollingSpeed)))
                  : ze(n);
            else {
              var i = Bt(n.dtop);
              (s.test.top = -n.dtop + "px"),
                clearTimeout(De),
                Jt(i.element, i.options, kt().scrollingSpeed, function () {
                  kt().scrollBar
                    ? (De = setTimeout(function () {
                        ze(n);
                      }, 30))
                    : (ze(n), gn({ G: !t || s.test.mn }));
                });
            }
            t &&
              (clearTimeout(Ee),
              (Ee = setTimeout(function () {
                gn({ G: !0 });
              }, e)));
          })(u),
          gn({ _: u.anchorLink }),
          xe(u.anchorLink, u.sectionIndex);
      }
    }
  }
  function ze(n) {
    gn({ B: !1 }),
      (function (n) {
        null != n.gn &&
          (n.isMovementUp
            ? H(m(Zn)[0], n.gn)
            : B(m(Zn)[mn().C.length - 1], n.gn),
          qt(mn().I.item.offsetTop),
          (function () {
            for (var n = m(ot), t = 0; t < n.length; t++) ni(n[t], "internal");
          })(),
          gn({ on: !1 }));
      })(n),
      X(kt().afterLoad) && !n.localIsResizing && te("afterLoad", n),
      ii(),
      n.localIsResizing || ie(n.element),
      E(n.element, Qn),
      R(U(n.element), Qn),
      Se(),
      gn({ G: !0 }),
      hn.R(In, n),
      X(n.callback) && n.callback();
  }
  function Ce(n, t) {
    jt("fitToSection", n, t);
  }
  function Ie() {
    pn.G && kt().fitToSection && (gn({ V: !0 }), Fe(pn.I), gn({ V: !1 }));
  }
  function Ne() {
    var n = kt().responsive || kt().responsiveWidth,
      t = kt().responsiveHeight,
      e = n && r.innerWidth < n,
      i = t && r.innerHeight < t;
    n && t ? Be(e || i) : n ? Be(e) : t && Be(i);
  }
  function Be(n) {
    var t = He();
    n
      ? t ||
        (ye(!1, "internal"),
        Ce(!1, "internal"),
        j(m(tt)),
        E(Yt, Kn),
        X(kt().afterResponsive) && kt().afterResponsive.call(xt(), n))
      : t &&
        (ye(Ot().autoScrolling, "internal"),
        Ce(Ot().autoScrolling, "internal"),
        L(m(tt)),
        R(Yt, Kn),
        X(kt().afterResponsive) && kt().afterResponsive.call(xt(), n));
  }
  function He() {
    return b(Yt, Kn);
  }
  function We(n) {
    kt().verticalCentered &&
      ((!kt().scrollOverflow && Ye.wn(n.item)) ||
        Ye.bn(n) ||
        b(n.item, ct) ||
        E(n.item, ct));
  }
  (s.moveTo = moveTo),
    (s.getScrollY = function () {
      return pn.scrollY;
    }),
    hn.D(xn, function () {
      clearTimeout(De), clearTimeout(Ee);
    }),
    (s.setFitToSection = Ce),
    (s.fitToSection = Ie),
    (s.setResponsive = Be);
  var Ve,
    Ue = null;
  function _e(n) {
    var t = n.item,
      e = n.yn.length,
      i = n.index();
    !mn().I && n.isVisible && (E(t, Yn), ii()),
      !Ue && n.isVisible && (Ue = mn().I.item),
      kt().paddingTop && T(t, { "padding-top": kt().paddingTop }),
      kt().paddingBottom && T(t, { "padding-bottom": kt().paddingBottom }),
      void 0 !== kt().sectionsColor[i] &&
        T(t, { "background-color": kt().sectionsColor[i] }),
      void 0 !== kt().anchors[i] && t.setAttribute("data-anchor", n.anchor),
      e || We(n);
  }
  function Ke() {
    kt().scrollOverflow && !kt().scrollBar && (Ye.Sn(), Ye.Tn());
  }
  function qe() {
    hn.removeListener(wn, Ke), $("keyup", Ye.Mn);
  }
  (s.getActiveSection = function () {
    return mn().I;
  }),
    hn.D(An, function () {
      hn.D(wn, Ke),
        hn.D(Cn, Ye.onLeave),
        hn.D(zn, Ye.onLeave),
        hn.D(Nn, Ye.afterLoad),
        hn.D(In, Ye.afterLoad),
        hn.D(xn, qe),
        q("keyup", Ye.Mn);
    });
  var Ge,
    $e,
    Ye = {
      An: null,
      xn: !0,
      kn: !0,
      On: null,
      jn: null,
      Ln: function (n) {
        var t = mn().I;
        if (
          !pn.G ||
          (d() &&
            kt().scrollOverflow &&
            Ye.bn(t) &&
            Ye.isScrolled(mn().X, t.item))
        )
          return _(n), !1;
      },
      Dn: function (n) {
        if (
          !sn() &&
          kt().keyboardScrolling &&
          [38, 33, 32, 40, 34, 36, 35].indexOf(n.keyCode) > -1 &&
          !Ye.kn
        )
          return _(n), !1;
      },
      Mn: function () {
        Ye.xn = pn.G;
      },
      onLeave: function () {
        clearTimeout(Ve), (Ye.kn = !1);
      },
      afterLoad: function () {
        (Ye.kn = !1),
          clearTimeout(Ve),
          (Ve = setTimeout(function () {
            Ye.xn = pn.G;
          }, 200));
      },
      En: function () {
        a.activeElement === this.An && (this.An.blur(), (Ye.kn = !1));
      },
      Tn: function () {
        if (kt().scrollOverflow && Ye.xn) {
          Ye.En();
          var n = Ye.Rn(mn().I.item);
          !n ||
            u ||
            c ||
            ((this.An = n),
            requestAnimationFrame(function () {
              n.focus({ Pn: !0 }), (Ye.kn = !0);
            })),
            (Ye.xn = !1);
        }
      },
      Sn: function () {
        kt().scrollOverflowMacStyle && !l && E(Yt, "fp-scroll-mac"),
          mn().dn.forEach(function (n) {
            if (
              !(
                (n.slides && n.slides.length) ||
                (b(n.item, "fp-auto-height-responsive") && He())
              )
            ) {
              var t,
                e = It(n.item),
                i = Ye.wn(n.item),
                o = (t = n).ln ? t : t.parent;
              if (f) {
                var r = i ? "addClass" : "removeClass";
                vn[r](o.item, vt), vn[r](n.item, vt);
              } else E(o.item, vt), E(n.item, vt);
              n.un || (Ye.Fn(e), Ye.zn(e)), (n.un = !0);
            }
          });
      },
      zn: function (n) {
        Ye.Rn(n).addEventListener("scroll", Ye.Cn),
          n.addEventListener("wheel", Ye.Ln, { passive: !1 }),
          n.addEventListener("keydown", Ye.Dn, { passive: !1 });
      },
      Fn: function (n) {
        var t = document.createElement("div");
        (t.className = ft), C(n, t), t.setAttribute("tabindex", "-1");
      },
      In: function (n) {
        var t = m(st, n)[0];
        t && (I(t), n.removeAttribute("tabindex"));
      },
      Rn: function (n) {
        var t = It(n);
        return m(st, t)[0] || t;
      },
      un: function (n) {
        return b(n, ft) || null != m(st, n)[0];
      },
      bn: function (n) {
        return n.ln && n.activeSlide ? n.activeSlide.un : n.un;
      },
      wn: function (n) {
        return Ye.Rn(n).scrollHeight > r.innerHeight;
      },
      isScrolled: function (n, t) {
        if (!pn.G) return !1;
        if (kt().scrollBar) return !0;
        var e = Ye.Rn(t);
        if (
          !kt().scrollOverflow ||
          !b(e, ft) ||
          b(t, "fp-noscroll") ||
          b(It(t), "fp-noscroll")
        )
          return !0;
        var i = f ? 1 : 0,
          o = e.scrollTop,
          r = "up" === n && o <= 0,
          a =
            "down" === n && e.scrollHeight <= Math.ceil(e.offsetHeight + o) + i,
          u = r || a;
        return u || "none" === n || (this.On = new Date().getTime()), u;
      },
      Nn: function () {
        this.jn = new Date().getTime();
        var n = this.jn - Ye.On,
          t = (u || c) && pn.J,
          e = pn.Z && n > 600;
        return (t && n > 400) || e;
      },
      Cn:
        ((Ge = 0),
        function (n) {
          var t = n.target.scrollTop,
            e = "none" !== pn.Y ? pn.Y : Ge < t ? "down" : "up";
          (Ge = t),
            X(kt().onScrollOverflow) &&
              te("onScrollOverflow", { position: t, direction: e }),
            b(n.target, ft) &&
              pn.G &&
              Ye.isScrolled(e, n.target) &&
              Ye.Nn() &&
              Ye.wn(mn().I.item) &&
              hn.R(On, { direction: e });
        }),
    };
  function Xe() {
    clearTimeout($e), gn({ W: !1 });
  }
  function Qe(n, t, e) {
    var i,
      o,
      r = N(n, Zn),
      a = mn().C.filter(function (n) {
        return n.item == r;
      })[0],
      u = a.slides.filter(function (n) {
        return n.item == t;
      })[0],
      l = {
        slides: n,
        destiny: t,
        direction: e,
        destinyPos: { left: t.offsetLeft },
        slideIndex: u.index(),
        section: r,
        sectionIndex: a.index(),
        anchorLink: a.anchor,
        slidesNav: m(dt, r)[0],
        slideAnchor: u.anchor,
        prevSlide: a.activeSlide.item,
        prevSlideIndex: a.activeSlide.index(),
        items: { section: a, origin: a.activeSlide, destination: u },
        localIsResizing: pn.V,
      };
    (l.Bn =
      ((i = l.prevSlideIndex),
      (o = l.slideIndex),
      i == o ? "none" : i > o ? "left" : "right")),
      (l.direction = l.direction ? l.direction : l.Bn),
      l.localIsResizing || gn({ G: !1 }),
      kt().onSlideLeave &&
      !l.localIsResizing &&
      "none" !== l.Bn &&
      X(kt().onSlideLeave) &&
      !1 === te("onSlideLeave", l)
        ? gn({ W: !1 })
        : (E(t, Yn),
          R(U(t), Yn),
          ii(),
          l.localIsResizing || (re(l.prevSlide), ue(u)),
          (function (n) {
            !kt().loopHorizontal &&
              kt().controlArrows &&
              (Z(m(wt, n.section), 0 !== n.slideIndex),
              Z(m(bt, n.section), null != A(n.destiny)));
          })(l),
          a.isActive &&
            !l.localIsResizing &&
            se(l.slideIndex, l.slideAnchor, l.anchorLink),
          hn.R(zn, l),
          (function (n, t, e) {
            var i,
              o,
              r = t.destinyPos;
            if (
              ((i = t.slidesNav),
              (o = t.slideIndex),
              kt().slidesNavigation &&
                null != i &&
                (R(m(Xn, i), Yn), E(m("a", m("li", i)[o]), Yn)),
              gn({ scrollX: Math.round(r.left) }),
              kt().css3)
            ) {
              var a = "translate3d(-" + Math.round(r.left) + "px, 0px, 0px)";
              (s.test.Hn[t.sectionIndex] = a),
                T(Wt(m(lt, n)), _t(a)),
                clearTimeout($e),
                ($e = setTimeout(function () {
                  Ze(t);
                }, kt().scrollingSpeed));
            } else
              (s.test.left[t.sectionIndex] = Math.round(r.left)),
                Jt(n, Math.round(r.left), kt().scrollingSpeed, function () {
                  Ze(t);
                });
          })(n, l));
  }
  function Je() {
    clearTimeout($e);
  }
  function Ze(n) {
    n.localIsResizing ||
      (X(kt().afterSlideLoad) && te("afterSlideLoad", n),
      gn({ G: !0 }),
      ie(n.destiny),
      hn.R(Nn, n)),
      gn({ W: !1 });
  }
  function ni(n, t) {
    Gt(0, "internal"),
      void 0 !== t && gn({ V: !0 }),
      Qe(N(n, at), n),
      void 0 !== t && gn({ V: !1 }),
      Gt(Ot().scrollingSpeed, "internal");
  }
  (s.landscapeScroll = Qe),
    hn.D(An, function () {
      hn.D(Fn, Xe);
    });
  var ti = null,
    ei = null;
  function ii() {
    (pn.I = null),
      pn.C.map(function (n) {
        var t = b(n.item, Yn);
        (n.isActive = t),
          (n.un = Ye.un(n.item)),
          t && (pn.I = n),
          n.slides.length &&
            ((n.activeSlide = null),
            n.slides.map(function (t) {
              var e = b(t.item, Yn);
              (t.un = Ye.un(n.item)),
                (t.isActive = e),
                e && (n.activeSlide = t);
            }));
      }),
      (function () {
        var n = pn.I,
          t = !!pn.I && pn.I.slides.length,
          e = pn.I ? pn.I.activeSlide : null;
        if (!n && pn.C.length && !mn().B && ti) {
          var i = ai(ti, pn.C);
          i && ((pn.I = i), (pn.I.isActive = !0), E(pn.I.item, Yn)),
            pn.I && qt(pn.I.item.offsetTop);
        }
        if (t && !e && ei) {
          var o = ai(ei, pn.I.slides);
          o &&
            ((pn.I.activeSlide = o),
            (pn.I.activeSlide.isActive = !0),
            E(pn.I.activeSlide.item, Yn)),
            pn.I.activeSlide && ni(pn.I.activeSlide.item, "internal");
        }
      })();
  }
  function oi() {
    var n = m(kt().sectionSelector, xt()),
      t = g(n),
      e = Array.from(n).map(function (n) {
        return new ui(n);
      }),
      i = e.filter(function (n) {
        return n.isVisible;
      }),
      o = i.reduce(function (n, t) {
        return n.concat(t.slides);
      }, []);
    (ti = ri(pn.I)),
      (ei = ri(pn.I ? pn.I.activeSlide : null)),
      (pn.P = t.length),
      (pn.F = i.reduce(function (n, t) {
        return n + t.slides.length;
      }, 0)),
      (pn.C = i),
      (pn.sn = e),
      (pn.slides = o),
      (pn.dn = pn.C.concat(pn.slides));
  }
  function ri(n) {
    if (!n) return null;
    var t = n ? n.item : null,
      e = n.ln ? pn.sn : pn.I.Wn;
    if (t) {
      var i = Pt(e, t);
      return i ? i.index() : null;
    }
    return null;
  }
  function ai(n, t) {
    var e,
      i = n - 1,
      o = n;
    do {
      if ((e = t[i] || t[o])) break;
      (i -= 1), (o += 1);
    } while (i >= 0 || o < t.length);
    return e;
  }
  var ui = function (n) {
    var t = this;
    [].push.call(arguments, kt().sectionSelector),
      Et.apply(this, arguments),
      (this.yn = m(kt().slideSelector, n)),
      (this.Wn = Array.from(this.yn).map(function (n) {
        return new ci(n, t);
      })),
      (this.slides = this.Wn.filter(function (n) {
        return n.isVisible;
      })),
      (this.activeSlide = this.slides.length
        ? this.slides.filter(function (n) {
            return n.isActive;
          })[0] || this.slides[0]
        : null);
  };
  (ui.prototype = Et.prototype), (ui.prototype.constructor = ui);
  var li,
    ci = function (n, t) {
      (this.parent = t), Et.call(this, n, kt().slideSelector);
    };
  function fi() {
    E(m(kt().sectionSelector, xt()), Jn), E(m(kt().slideSelector, xt()), et);
  }
  function si(n) {
    var t = n.slides.length,
      e = n.yn,
      i = n.slides,
      o = 100 * t,
      r = 100 / t;
    if (!m(at, n.item)[0]) {
      var u = a.createElement("div");
      (u.className = rt), z(e, u);
      var l = a.createElement("div");
      (l.className = ut), z(e, l);
    }
    T(m(lt, n.item), { width: o + "%" }),
      t > 1 &&
        (kt().controlArrows &&
          (function (n) {
            var t = n.item,
              e = [
                nn(kt().controlArrowsHTML[0]),
                nn(kt().controlArrowsHTML[1]),
              ];
            B(m(at, t)[0], e),
              E(e, pt),
              E(e[0], mt),
              E(e[1], "fp-next"),
              "#fff" !== kt().controlArrowColor &&
                (T(m(bt, t), {
                  "border-color":
                    "transparent transparent transparent " +
                    kt().controlArrowColor,
                }),
                T(m(wt, t), {
                  "border-color":
                    "transparent " +
                    kt().controlArrowColor +
                    " transparent transparent",
                })),
              kt().loopHorizontal || j(m(wt, t));
          })(n),
        kt().slidesNavigation &&
          (function (n) {
            var t = n.item,
              e = n.slides.length;
            P(nn('<div class="fp-slidesNav"><ul></ul></div>'), t);
            var i = m(dt, t)[0];
            E(i, "fp-" + kt().slidesNavPosition);
            for (var o = 0; o < e; o++)
              P(
                nn(
                  '<li><a href="#"><span class="fp-sr-only">' +
                    de(o, "Slide", m(it, t)[o]) +
                    "</span><span></span></a></li>"
                ),
                m("ul", i)[0]
              );
            T(i, { "margin-left": "-" + i.innerWidth / 2 + "px" });
            var r = n.activeSlide ? n.activeSlide.index() : 0;
            E(m("a", m("li", i)[r]), Yn);
          })(n)),
      i.forEach(function (n) {
        T(n.item, { width: r + "%" }), kt().verticalCentered && We(n);
      });
    var c = n.activeSlide || null;
    null != c &&
    pn.I &&
    (0 !== pn.I.index() || (0 === pn.I.index() && 0 !== c.index()))
      ? ni(c.item, "internal")
      : E(e[0], Yn);
  }
  (ci.prototype = Et.prototype), (ci.prototype.constructor = ui);
  var vi = { attributes: !1, subtree: !0, childList: !0, characterData: !0 };
  function di() {
    return g(m(kt().slideSelector, xt())).length !== mn().F;
  }
  function hi(n) {
    var t = di();
    (di() || g(m(kt().sectionSelector, xt())).length !== mn().P) &&
      !pn.on &&
      (kt().observer && li && li.disconnect(),
      oi(),
      ii(),
      (kt().anchors = []),
      tn(m(tt)),
      fi(),
      Lt(),
      kt().navigation && Me(),
      t && (tn(m(dt)), tn(m(gt))),
      mn().C.forEach(function (n) {
        n.slides.length ? t && si(n) : _e(n);
      })),
      kt().observer && li && m(Un)[0] && li.observe(m(Un)[0], vi);
  }
  hn.D(An, function () {
    var n, t, e;
    kt().observer &&
      "MutationObserver" in window &&
      m(Un)[0] &&
      ((n = m(Un)[0]),
      (t = vi),
      (e = new MutationObserver(hi)).observe(n, t),
      (li = e)),
      hn.D(kn, hi);
  }),
    (s.render = hi);
  var pi = (function () {
    var n = !1;
    try {
      var t = Object.defineProperty({}, "passive", {
        get: function () {
          n = !0;
        },
      });
      G("testPassive", null, t), Y("testPassive", null, t);
    } catch (n) {}
    return function () {
      return n;
    };
  })();
  function gi() {
    return !!pi() && { passive: !1 };
  }
  var mi,
    wi,
    bi,
    yi,
    Si =
      ((bi = new Date().getTime()),
      (yi = []),
      {
        Vn: function (n) {
          var t = (n = n || r.event).wheelDelta || -n.deltaY || -n.detail,
            e = Math.max(-1, Math.min(1, t)),
            i = void 0 !== n.wheelDeltaX || void 0 !== n.deltaX;
          mi =
            Math.abs(n.wheelDeltaX) < Math.abs(n.wheelDelta) ||
            Math.abs(n.deltaX) < Math.abs(n.deltaY) ||
            !i;
          var o = new Date().getTime();
          (wi = e < 0 ? "down" : "up"),
            yi.length > 149 && yi.shift(),
            yi.push(Math.abs(t));
          var a = o - bi;
          (bi = o), a > 200 && (yi = []);
        },
        Un: function () {
          var n = ln(yi, 10) >= ln(yi, 70);
          return !!yi.length && n && mi;
        },
        _n: function () {
          return wi;
        },
      });
  function Ti() {
    var n = kt().css3
        ? V() + y()
        : un(mn().C).item.offsetTop + un(mn().C).item.offsetHeight,
      t = Bt(n);
    (s.test.top = -n + "px"),
      gn({ G: !1 }),
      Jt(t.element, t.options, kt().scrollingSpeed, function () {
        setTimeout(function () {
          gn({ B: !0 }), gn({ G: !0 });
        }, 30);
      });
  }
  function Mi() {
    xt().getBoundingClientRect().bottom >= 0 && Ai();
  }
  function Ai() {
    var n = Bt(un(mn().C).item.offsetTop);
    gn({ G: !1 }),
      Jt(n.element, n.options, kt().scrollingSpeed, function () {
        gn({ G: !0 }), gn({ B: !1 }), gn({ Kn: !1 });
      });
  }
  var xi,
    ki,
    Oi,
    ji =
      ((xi = !1),
      (ki = {}),
      (Oi = {}),
      function (n, t, e) {
        switch (n) {
          case "set":
            (ki[t] = new Date().getTime()), (Oi[t] = e);
            break;
          case "isNewKeyframe":
            var i = new Date().getTime();
            xi = i - ki[t] > Oi[t];
        }
        return xi;
      });
  function Li() {
    var n = mn().I.next();
    n || (!kt().loopBottom && !kt().continuousVertical) || (n = mn().C[0]),
      null != n
        ? Fe(n, null, !1)
        : xt().scrollHeight < Yt.scrollHeight &&
          kt().scrollBar &&
          kt().scrollBeyondFullpage &&
          hn.R(Pn);
  }
  function Di() {
    var n = mn().I.prev();
    n || (!kt().loopTop && !kt().continuousVertical) || (n = un(mn().C)),
      null != n && Fe(n, null, !0);
  }
  (s.moveSectionDown = Li), (s.moveSectionUp = Di);
  var Ei = 0;
  function Ri(n) {
    kt().autoScrolling &&
      (pn.G &&
        (n.pageY < Ei && me().m.up
          ? Di()
          : n.pageY > Ei && me().m.down && Li()),
      (Ei = n.pageY));
  }
  function Pi(n) {
    if (me().m[n]) {
      var t = "down" === n ? Li : Di;
      kt().scrollOverflow && Ye.bn(mn().I)
        ? Ye.isScrolled(n, mn().I.item) && Ye.Nn() && t()
        : t();
    }
  }
  var Fi,
    zi,
    Ci,
    Ii,
    Ni = 0,
    Bi = 0,
    Hi = 0,
    Wi = 0,
    Vi =
      (r.PointerEvent && (Ii = { down: "pointerdown", move: "pointermove" }),
      Ii),
    Ui = {
      qn: "ontouchmove" in window ? "touchmove" : Vi ? Vi.move : null,
      Gn: "ontouchstart" in window ? "touchstart" : Vi ? Vi.down : null,
    };
  function _i(n) {
    var t = N(n.target, Zn) || mn().I.item,
      e = Ye.bn(mn().I);
    if (Ki(n)) {
      gn({ J: !0, Z: !1 }),
        kt().autoScrolling && ((e && !pn.G) || kt().scrollBar) && _(n);
      var i = $i(n);
      (Hi = i.y), (Wi = i.x);
      var o = Math.abs(Ni - Hi) > (r.innerHeight / 100) * kt().touchSensitivity,
        a = Math.abs(Bi - Wi) > (S() / 100) * kt().touchSensitivity,
        u = m(at, t).length && Math.abs(Bi - Wi) > Math.abs(Ni - Hi),
        l = Ni > Hi ? "down" : "up";
      gn({ Y: u ? (Bi > Wi ? "right" : "left") : l }),
        u
          ? !pn.W &&
            a &&
            (Bi > Wi
              ? me().m.right && hn.R(Sn, { section: t })
              : me().m.left && hn.R(yn, { section: t }))
          : kt().autoScrolling && pn.G && o && Pi(l);
    }
  }
  function Ki(n) {
    return void 0 === n.pointerType || "mouse" != n.pointerType;
  }
  function qi(n) {
    if ((kt().fitToSection && gn({ q: !1 }), Ki(n))) {
      var t = $i(n);
      (Ni = t.y), (Bi = t.x);
    }
    G("touchend", Gi);
  }
  function Gi() {
    Y("touchend", Gi), gn({ J: !1 });
  }
  function $i(n) {
    var t = {};
    return (
      (t.y =
        void 0 !== n.pageY && (n.pageY || n.pageX)
          ? n.pageY
          : n.touches[0].pageY),
      (t.x =
        void 0 !== n.pageX && (n.pageY || n.pageX)
          ? n.pageX
          : n.touches[0].pageX),
      c &&
        Ki(n) &&
        kt().scrollBar &&
        void 0 !== n.touches &&
        ((t.y = n.touches[0].pageY), (t.x = n.touches[0].pageX)),
      t
    );
  }
  function Yi(n) {
    kt().autoScrolling && Ki(n) && me().m.up && (pn.G || _(n));
  }
  function Xi(n, t) {
    var e = null == t ? mn().I.item : t,
      i = Pt(pn.C, e),
      o = m(at, e)[0];
    if (!(null == o || pn.W || i.slides.length < 2)) {
      var r = i.activeSlide,
        a = "left" === n ? r.prev() : r.next();
      if (!a) {
        if (!kt().loopHorizontal) return;
        a = "left" === n ? un(i.slides) : i.slides[0];
      }
      gn({ W: !s.test.mn }), Qe(o, a.item, n);
    }
  }
  function Qi(n) {
    Xi("left", n);
  }
  function Ji(n) {
    Xi("right", n);
  }
  function Zi(n) {
    var t = mn().C.filter(function (t) {
      return t.anchor === n;
    })[0];
    if (!t) {
      var e = void 0 !== n ? n - 1 : 0;
      t = mn().C[e];
    }
    return t;
  }
  function no(n) {
    null != n && Qe(N(n, at), n);
  }
  function to(n, t) {
    var e = Zi(n);
    if (null != e) {
      var i = (function (n, t) {
        var e = t.slides.filter(function (t) {
          return t.anchor === n;
        })[0];
        return (
          null == e && ((n = void 0 !== n ? n : 0), (e = t.slides[n])),
          e ? e.item : null
        );
      })(t, e);
      (e.anchor && e.anchor === pn._) || b(e.item, Yn)
        ? no(i)
        : Fe(e, function () {
            no(i);
          });
    }
  }
  function eo(n, t) {
    var e = Zi(n);
    void 0 !== t ? to(n, t) : null != e && Fe(e);
  }
  function io() {
    clearTimeout(zi), $("keydown", oo), $("keyup", ro);
  }
  function oo(n) {
    clearTimeout(zi);
    var t = n.keyCode,
      e = [37, 39].indexOf(t) > -1,
      i = kt().autoScrolling || kt().fitToSection || e;
    9 === t
      ? (function (n) {
          var t = n.shiftKey,
            e = a.activeElement,
            i = fo(It(mn().I.item));
          function o(n) {
            return _(n), i[0] ? i[0].focus() : null;
          }
          if (pn.G) {
            if (
              !(function (n) {
                var t = fo(a),
                  e = t.indexOf(a.activeElement),
                  i = t[n.shiftKey ? e - 1 : e + 1],
                  o = N(i, it),
                  r = N(i, Zn);
                return !o && !r;
              })(n)
            ) {
              e
                ? null ==
                    N(
                      e,
                      ".fp-section.active,.fp-section.active .fp-slide.active"
                    ) && (e = o(n))
                : o(n);
              var r = e == i[0],
                u = e == i[i.length - 1],
                l = t && r;
              if (l || (!t && u)) {
                _(n);
                var c = (function (n) {
                    var t,
                      e = n ? "prevPanel" : "nextPanel",
                      i = [],
                      o = Nt(
                        (pn.I && pn.I.activeSlide ? pn.I.activeSlide : pn.I)[
                          e
                        ]()
                      );
                    do {
                      (i = fo(o.item)).length &&
                        (t = { $n: o, Yn: i[n ? i.length - 1 : 0] }),
                        (o = Nt(o[e]()));
                    } while (o && 0 === i.length);
                    return t;
                  })(l),
                  f = c ? c.$n : null;
                if (f) {
                  var s = f.ln ? f : f.parent;
                  hn.R(jn, {
                    Xn: s.index() + 1,
                    slideAnchor: f.ln ? 0 : f.index(),
                  }),
                    (Ci = c.Yn),
                    _(n);
                }
              }
            }
          } else _(n);
        })(n)
      : !sn() &&
        kt().keyboardScrolling &&
        i &&
        ((Fi = n.ctrlKey),
        (zi = setTimeout(function () {
          !(function (n) {
            var t = n.shiftKey,
              e = a.activeElement,
              i = J(e, "video") || J(e, "audio"),
              o = Ye.isScrolled("up", mn().I.item),
              r = Ye.isScrolled("down", mn().I.item),
              u = [37, 39].indexOf(n.keyCode) > -1;
            if (
              ((function (n) {
                (function (n) {
                  return [40, 38, 32, 33, 34].indexOf(n.keyCode) > -1 && !pn.B;
                })(n) &&
                  !N(n.target, st) &&
                  n.preventDefault();
              })(n),
              pn.G || u)
            )
              switch ((gn({ N: "keydown" }), n.keyCode)) {
                case 38:
                case 33:
                  me().k.up && o ? (pn.B ? hn.R(Ln, { e: n }) : Di()) : Ye.Tn();
                  break;
                case 32:
                  if (t && me().k.up && !i && o) {
                    Di();
                    break;
                  }
                case 40:
                case 34:
                  if (me().k.down && r) {
                    if (pn.B) return;
                    (32 === n.keyCode && i) || Li();
                  } else Ye.Tn();
                  break;
                case 36:
                  me().k.up && eo(1);
                  break;
                case 35:
                  me().k.down && eo(mn().C.length);
                  break;
                case 37:
                  me().k.left && Qi();
                  break;
                case 39:
                  me().k.right && Ji();
              }
          })(n);
        }, 0)));
  }
  function ro(n) {
    pn.nn && (Fi = n.ctrlKey);
  }
  function ao() {
    gn({ nn: !1 }), (Fi = !1);
  }
  function uo(n) {
    co();
  }
  function lo(n) {
    (N(Ci, it) && !N(Ci, ot)) || co();
  }
  function co() {
    Ci && (Ci.focus(), (Ci = null));
  }
  function fo(n) {
    return [].slice
      .call(
        m(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], summary:not([disabled]), [contenteditable]',
          n
        )
      )
      .filter(function (n) {
        return "-1" !== K(n, "tabindex") && null !== n.offsetParent;
      });
  }
  (s.moveSlideLeft = Qi),
    (s.moveSlideRight = Ji),
    (s.moveTo = eo),
    hn.D(An, function () {
      G("blur", ao),
        q("keydown", oo),
        q("keyup", ro),
        hn.D(xn, io),
        hn.D(Nn, uo),
        hn.D(In, lo);
    });
  var so = new Date().getTime(),
    vo = [];
  function ho(n) {
    n
      ? ((function () {
          var n,
            t = "";
          r.addEventListener
            ? (n = "addEventListener")
            : ((n = "attachEvent"), (t = "on"));
          var e =
              "onwheel" in a.createElement("div")
                ? "wheel"
                : void 0 !== a.onmousewheel
                ? "mousewheel"
                : "DOMMouseScroll",
            i = gi();
          "DOMMouseScroll" == e
            ? a[n](t + "MozMousePixelScroll", po, i)
            : a[n](t + e, po, i);
        })(),
        xt().addEventListener("mousedown", go),
        xt().addEventListener("mouseup", mo))
      : (a.addEventListener
          ? ($("mousewheel", po, !1),
            $("wheel", po, !1),
            $("MozMousePixelScroll", po, !1))
          : a.detachEvent("onmousewheel", po),
        xt().removeEventListener("mousedown", go),
        xt().removeEventListener("mouseup", mo));
  }
  function po(n) {
    var t = new Date().getTime(),
      e = b(m(".fp-completely")[0], "fp-normal-scroll"),
      i = (function (n, t) {
        new Date().getTime();
        var e =
            mn().B && n.getBoundingClientRect().bottom >= 0 && "up" === Si._n(),
          i = mn().Kn;
        if (i) return _(t), !1;
        if (mn().B) {
          if (e) {
            var o;
            if (!(i || (ji("isNewKeyframe", "beyondFullpage") && Si.Un())))
              return (
                (o = Bt(
                  un(mn().C).item.offsetTop + un(mn().C).item.offsetHeight
                )).element.scrollTo(0, o.options),
                gn({ Kn: !1 }),
                _(t),
                !1
              );
            if (Si.Un())
              return (
                (e = !1), gn({ Kn: !0 }), gn({ N: "wheel" }), Ai(), _(t), !1
              );
          } else ji("set", "beyondFullpage", 1e3);
          if (!i && !e) return !0;
        }
      })(xt(), n);
    if ((pn.Z || gn({ J: !1, Z: !0, Y: "none" }), !me().m.down && !me().m.up))
      return !1;
    if (i) return !0;
    if (!1 === i) return _(n), !1;
    if (kt().autoScrolling && !Fi && !e) {
      var o = (n = n || r.event).wheelDelta || -n.deltaY || -n.detail,
        a = Math.max(-1, Math.min(1, o)),
        u = void 0 !== n.wheelDeltaX || void 0 !== n.deltaX,
        l =
          Math.abs(n.wheelDeltaX) < Math.abs(n.wheelDelta) ||
          Math.abs(n.deltaX) < Math.abs(n.deltaY) ||
          !u,
        c = a < 0 ? "down" : a > 0 ? "up" : "none";
      vo.length > 149 && vo.shift(),
        vo.push(Math.abs(o)),
        kt().scrollBar && _(n);
      var f = t - so;
      return (
        (so = t),
        f > 200 && (vo = []),
        gn({ X: c }),
        pn.G &&
          ln(vo, 10) >= ln(vo, 70) &&
          l &&
          (gn({ N: "wheel" }), Pi(a < 0 ? "down" : "up")),
        !1
      );
    }
    kt().fitToSection && gn({ q: !1 });
  }
  function go(n) {
    var t;
    2 == n.which &&
      ((t = n.pageY), (Ei = t), xt().addEventListener("mousemove", Ri));
  }
  function mo(n) {
    2 == n.which && xt().removeEventListener("mousemove", Ri);
  }
  function wo(n) {
    n
      ? (ho(!0),
        (function () {
          if (Ui.qn && (u || c)) {
            kt().autoScrolling &&
              (Yt.removeEventListener(Ui.qn, Yi, { passive: !1 }),
              Yt.addEventListener(Ui.qn, Yi, { passive: !1 }));
            var n = kt().touchWrapper;
            n.removeEventListener(Ui.Gn, qi),
              n.removeEventListener(Ui.qn, _i, { passive: !1 }),
              n.addEventListener(Ui.Gn, qi),
              n.addEventListener(Ui.qn, _i, { passive: !1 });
          }
        })())
      : (ho(!1),
        (function () {
          if (Ui.qn && (u || c)) {
            kt().autoScrolling &&
              (Yt.removeEventListener(Ui.qn, _i, { passive: !1 }),
              Yt.removeEventListener(Ui.qn, Yi, { passive: !1 }));
            var n = kt().touchWrapper;
            n.removeEventListener(Ui.Gn, qi),
              n.removeEventListener(Ui.qn, _i, { passive: !1 });
          }
        })());
  }
  s.setMouseWheelScrolling = ho;
  var bo = !0;
  function yo() {
    ["mouseenter", "touchstart", "mouseleave", "touchend"].forEach(function (
      n
    ) {
      $(n, To, !0);
    });
  }
  function So(n, t) {
    (document["fp_" + n] = t), q(n, To, !0);
  }
  function To(n) {
    var t = n.type,
      e = !1,
      i = "mouseleave" === t ? n.toElement || n.relatedTarget : n.target;
    i != document && i
      ? ("touchend" === t &&
          ((bo = !1),
          setTimeout(function () {
            bo = !0;
          }, 800)),
        ("mouseenter" !== t || bo) &&
          (kt()
            .normalScrollElements.split(",")
            .forEach(function (n) {
              if (!e) {
                var t = J(i, n),
                  o = N(i, n);
                (t || o) &&
                  (s.shared.Qn || wo(!1), (s.shared.Qn = !0), (e = !0));
              }
            }),
          !e && s.shared.Qn && (wo(!0), (s.shared.Qn = !1))))
      : wo(!0);
  }
  function Mo(n, t) {
    Gt(0, "internal"), eo(n, t), Gt(Ot().scrollingSpeed, "internal");
  }
  hn.D(An, function () {
    kt().normalScrollElements &&
      (["mouseenter", "touchstart"].forEach(function (n) {
        So(n, !1);
      }),
      ["mouseleave", "touchend"].forEach(function (n) {
        So(n, !0);
      })),
      hn.D(xn, yo);
  }),
    (s.silentMoveTo = Mo);
  var Ao,
    xo,
    ko = y(),
    Oo = S(),
    jo = !1;
  function Lo() {
    clearTimeout(Ao), clearTimeout(xo), Y("resize", Do);
  }
  function Do() {
    jo ||
      (((kt().autoScrolling && !kt().scrollBar) || !kt().fitToSection) &&
        Ro(y())),
      pn.an &&
        (function () {
          if (u)
            for (var n = 0; n < 4; n++)
              xo = setTimeout(function () {
                window.requestAnimationFrame(function () {
                  kt().autoScrolling &&
                    !kt().scrollBar &&
                    (gn({ V: !0 }), Mo(pn.I.index() + 1), gn({ V: !1 }));
                });
              }, 200 * n);
        })(),
      (jo = !0),
      clearTimeout(Ao),
      (Ao = setTimeout(function () {
        !(function () {
          if (
            (gn({ V: !0 }),
            (!u || kt().adjustOnNavChange) &&
              (Ro(""), kt().autoScrolling || pn.B || Po()),
            hn.R(kn),
            ii(),
            Ne(),
            u)
          ) {
            var n = a.activeElement;
            if (!J(n, "textarea") && !J(n, "input") && !J(n, "select")) {
              var t = y();
              Math.abs(t - ko) > (20 * Math.max(ko, t)) / 100 &&
                (Eo(!0), (ko = t));
            }
          } else
            (e = y()),
              (i = S()),
              (pn.en === e && Oo === i) || (gn({ en: e }), (Oo = i), Eo(!0));
          var e, i;
          gn({ V: !1 });
        })(),
          (jo = !1);
      }, 400));
  }
  function Eo(n) {
    if (!b(xt(), Gn)) {
      gn({ V: !0, en: y(), Jn: S() });
      for (var t = mn().C, e = 0; e < t.length; ++e) {
        var i = t[e],
          o = m(at, i.item)[0];
        i.slides.length > 1 && Qe(o, i.activeSlide.item);
      }
      kt().scrollOverflow && Ye.Sn();
      var a = mn().I.index();
      pn.B || (a && Mo(a + 1)),
        gn({ V: !1 }),
        X(kt().afterResize) &&
          n &&
          kt().afterResize.call(xt(), r.innerWidth, r.innerHeight),
        X(kt().afterReBuild) && !n && kt().afterReBuild.call(xt()),
        Q(xt(), "afterRebuild");
    }
  }
  function Ro(n) {
    var t = "" === n ? "" : n + "px";
    mn().C.forEach(function (n) {
      T(n.item, { height: t });
    });
  }
  function Po() {
    if (!kt().autoScrolling || kt().scrollBar) {
      var n = 0.01 * r.innerHeight;
      a.documentElement.style.setProperty("--vh", "".concat(n, "px"));
    }
  }
  function Fo() {
    var n,
      t,
      e = r.location.hash;
    if (e.length) {
      var i = e.replace("#", "").split("/"),
        o = e.indexOf("#/") > -1;
      n = o ? "/" + i[1] : decodeURIComponent(i[0]);
      var a = o ? i[2] : i[1];
      a && a.length && (t = decodeURIComponent(a));
    }
    return { section: n, pn: t };
  }
  function zo() {
    Y("hashchange", Co);
  }
  function Co() {
    if (!pn.U && !kt().lockAnchors) {
      var n = Fo(),
        t = n.section,
        e = n.pn,
        i = void 0 === pn._,
        o = void 0 === pn._ && void 0 === e && !pn.W;
      t &&
        t.length &&
        ((t && t !== pn._ && !i) || o || (!pn.W && pn.K != e)) &&
        hn.R(jn, { Xn: t, slideAnchor: e });
    }
  }
  function Io(n) {
    var t = n.target;
    N(t, kt().menu + " [data-menuanchor]") && No.call(t, n.e);
  }
  function No(n) {
    if (
      (gn({ N: "menu" }),
      m(kt().menu)[0] && (kt().lockAnchors || !kt().anchors.length))
    ) {
      _(n);
      var t = N(this, "[data-menuanchor]");
      hn.R(Dn, { anchor: K(t, "data-menuanchor") });
    }
  }
  function Bo(n) {
    var t = n.target;
    t && N(t, "#fp-nav a")
      ? Ae.call(t, n.e)
      : J(t, ".fp-tooltip")
      ? Te.call(t)
      : (J(t, ht) || null != N(t, ht)) && he.call(t, n.e);
  }
  (s.reBuild = Eo),
    hn.D(An, function () {
      Do(), Po(), G("resize", Do), hn.D(xn, Lo);
    }),
    (s.setLockAnchors = function (n) {
      kt().lockAnchors = n;
    }),
    hn.D(An, function () {
      G("hashchange", Co), hn.D(xn, zo);
    }),
    hn.D(An, function () {
      q("wheel", Si.Vn, gi()), hn.D(Pn, Ti), hn.D(Ln, Mi);
    }),
    hn.D(An, function () {
      hn.D(bn, Io);
    }),
    hn.D(An, function () {
      hn.D(bn, Bo);
    });
  var Ho,
    Wo,
    Vo = 0;
  function Uo(n) {
    var t, e, i, o, r;
    if (
      !pn.V &&
      mn().I &&
      (un(mn().C),
      !mn().B && !mn().Kn && (!kt().autoScrolling || kt().scrollBar))
    ) {
      var a = V(),
        l = (function (n) {
          var t = n > Vo ? "down" : "up";
          return (Vo = n), gn({ tn: n }), t;
        })(a),
        c = 0,
        f = a + y() / 2,
        s = Yt.scrollHeight - y() === a,
        v = mn().C;
      if ((gn({ scrollY: a }), s)) c = v.length - 1;
      else if (a)
        for (var d = 0; d < v.length; ++d) v[d].item.offsetTop <= f && (c = d);
      else c = 0;
      if (
        ((i = l),
        (o = mn().I.item.offsetTop),
        (r = o + y()),
        ("up" == i ? r >= V() + y() : o <= V()) &&
          (b(mn().I.item, Qn) || (E(mn().I.item, Qn), R(U(mn().I.item), Qn))),
        (e = (t = v[c]).item),
        !t.isActive)
      ) {
        gn({ U: !0 });
        var h,
          p,
          g = mn().I.item,
          m = mn().I.index() + 1,
          w = Vt(mn().I, e),
          S = t.anchor,
          T = t.index() + 1,
          M = t.activeSlide,
          A = {
            I: g,
            sectionIndex: T - 1,
            anchorLink: S,
            element: e,
            leavingSection: m,
            direction: w,
            items: { origin: mn().I, destination: t },
          };
        M && ((p = M.anchor), (h = M.index())),
          pn.G &&
            (E(e, Yn),
            R(U(e), Yn),
            X(kt().beforeLeave) && Pe("beforeLeave", A),
            X(kt().onLeave) && te("onLeave", A),
            X(kt().afterLoad) && te("afterLoad", A),
            re(g),
            ue(t),
            ie(e),
            xe(S, T - 1),
            kt().anchors.length && gn({ _: S }),
            ii(),
            se(h, p, S)),
          clearTimeout(Ho),
          (Ho = setTimeout(function () {
            gn({ U: !1 });
          }, 100));
      }
      kt().fitToSection &&
        pn.G &&
        (clearTimeout(Wo),
        (Wo = setTimeout(function () {
          var n;
          if (
            !pn.C.filter(function (n) {
              var t = n.item.getBoundingClientRect();
              return (
                Math.round(t.bottom) === Math.round(y()) ||
                0 === Math.round(t.top)
              );
            }).length
          ) {
            if (
              u &&
              (n = document.activeElement) &&
              n.matches("input, textarea")
            )
              return;
            Ie();
          }
        }, kt().fitToSectionDelay)));
    }
  }
  function _o(n) {
    var t = n.items.destination.activeSlide;
    gn({ scrollX: t ? Math.round(t.offsetLeft) : 0 });
  }
  function Ko(n) {
    var t = kt().skipIntermediateItems,
      e = n.items.origin.ln ? "sections" : "slides",
      i = Math.abs(n.items.origin.index() - n.items.destination.index()) > 1;
    (!0 === t || t === e) && i && Gt(0, "internal");
  }
  function qo(n) {
    kt().skipIntermediateItems &&
      jt("scrollingSpeed", Ot().scrollingSpeed, "internal");
  }
  function Go(n, t) {
    void 0 !== t
      ? (t = t.replace(/ /g, "").split(",")).forEach(function (t) {
          ge(n, t, "k");
        })
      : (ge(n, "all", "k"), (kt().keyboardScrolling = n));
  }
  function $o(n) {
    var t = n.index();
    void 0 !== kt().anchors[t] && n.isActive && xe(kt().anchors[t], t),
      kt().menu &&
        kt().css3 &&
        null != N(m(kt().menu)[0], Un) &&
        m(kt().menu).forEach(function (n) {
          Yt.appendChild(n);
        });
  }
  function Yo() {
    var n,
      t,
      e = mn().I,
      i = mn().I.item;
    E(i, Qn),
      ue(mn().I),
      Se(),
      ie(i),
      (t = Zi((n = Fo()).section)),
      (n.section && t && (void 0 === t || t.index() !== k(Ue))) ||
        !X(kt().afterLoad) ||
        te("afterLoad", {
          I: i,
          element: i,
          direction: null,
          anchorLink: e.anchor,
          sectionIndex: e.index(),
          items: { origin: mn().I, destination: mn().I },
        }),
      X(kt().afterRender) && te("afterRender");
  }
  function Xo(n, t) {
    void 0 !== t
      ? (t = t.replace(/ /g, "").split(",")).forEach(function (t) {
          ge(n, t, "m");
        })
      : ge(n, "all", "m");
  }
  function Qo() {
    var n = Fo(),
      t = n.section,
      e = n.pn;
    t ? (kt().animateAnchor ? to(t, e) : Mo(t, e)) : hn.R(wn, null);
  }
  function Jo() {
    oi(),
      ii(),
      (kt().scrollBar = kt().scrollBar || kt().hybrid),
      Lt(),
      (function () {
        T(fn(xt(), "body"), { height: "100%", position: "relative" }),
          E(xt(), Vn),
          E(Xt, $n),
          gn({ en: y() }),
          R(xt(), Gn),
          fi();
        for (var n = mn().sn, t = 0; t < n.length; t++) {
          var e = n[t],
            i = e.yn,
            o = K(e.item, "style");
          o && e.item.setAttribute("data-fp-styles", o),
            _e(e),
            $o(e),
            i.length > 0 && si(e);
        }
        kt().fixedElements &&
          kt().css3 &&
          m(kt().fixedElements).forEach(function (n) {
            Yt.appendChild(n);
          }),
          kt().navigation && Me(),
          m('iframe[src*="youtube.com/embed/"]', xt()).forEach(function (n) {
            var t, e;
            (e = K((t = n), "src")),
              t.setAttribute(
                "src",
                e + (/\?/.test(e) ? "&" : "?") + "enablejsapi=1"
              );
          }),
          kt().scrollOverflow && Ye.Sn();
      })(),
      Xo(!0),
      wo(!0),
      ye(kt().autoScrolling, "internal"),
      Ne(),
      ce(),
      "complete" === a.readyState && Qo(),
      G("load", Qo),
      Yo(),
      oi(),
      ii();
  }
  function Zo() {
    var n = kt().licenseKey;
    "" === kt().licenseKey.trim()
      ? (h(
          "error",
          ""
        ),
        h("error", "https://alvarotrigo.com/fullPage/docs/#licensekey"))
      : (kt() && pn.Zn) || a.domain.indexOf("alvarotrigo.com") > -1
      ? n && n.length
      : (h(
          "error",
          "Incorrect `licenseKey`. Get one for fullPage.js version 4 here:"
        ),
        h("error", "https://alvarotrigo.com/fullPage/pricing")),
      b(Xt, $n)
        ? h(
            "error",
            "Fullpage.js can only be initialized once and you are doing it multiple times!"
          )
        : (kt().continuousVertical &&
            (kt().loopTop || kt().loopBottom) &&
            ((kt().continuousVertical = !1),
            h(
              "warn",
              "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled"
            )),
          !kt().scrollOverflow ||
            (!kt().scrollBar && kt().autoScrolling) ||
            h(
              "warn",
              "Options scrollBar:true and autoScrolling:false are mutually exclusive with scrollOverflow:true. Sections with scrollOverflow might not work well in Firefox"
            ),
          !kt().continuousVertical ||
            (!kt().scrollBar && kt().autoScrolling) ||
            ((kt().continuousVertical = !1),
            h(
              "warn",
              "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled"
            )),
          v.forEach(function (n) {
            kt()[n] &&
              h(
                "warn",
                "fullpage.js extensions require fullpage.extensions.min.js file instead of the usual fullpage.js. Requested: " +
                  n
              );
          }),
          kt().anchors.forEach(function (n) {
            var t = [].slice.call(m("[name]")).filter(function (t) {
                return (
                  K(t, "name") && K(t, "name").toLowerCase() == n.toLowerCase()
                );
              }),
              e = [].slice.call(m("[id]")).filter(function (t) {
                return (
                  K(t, "id") && K(t, "id").toLowerCase() == n.toLowerCase()
                );
              });
            if (e.length || t.length) {
              h(
                "error",
                "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."
              );
              var i = e.length ? "id" : "name";
              (e.length || t.length) &&
                h(
                  "error",
                  '"' +
                    n +
                    '" is is being used by another element `' +
                    i +
                    "` property"
                );
            }
          }));
  }
  function nr(n, t) {
    var e;
    if (
      ((Yt = m("body")[0]),
      (Xt = m("html")[0]),
      (Qt = m("html, body")),
      !b(Xt, $n))
    )
      return (
        "touchWrapper",
        (e = "string" == typeof n ? m(n)[0] : n),
        (yt.touchWrapper = e),
        (function (n) {
          (At = w({}, yt, n)), (Mt = Object.assign({}, At));
        })(t),
        (function (n) {
          St = n;
        })("string" == typeof n ? m(n)[0] : n),
        hn.R(Tn),
        Zo(),
        (s.getFullpageData = function () {
          return { options: kt() };
        }),
        (s.version = "4.0.33"),
        (s.test = Object.assign(s.test, {
          top: "0px",
          hn: "translate3d(0px, 0px, 0px)",
          Hn: (function () {
            for (
              var n = [], t = 0;
              t < m(kt().sectionSelector, xt()).length;
              t++
            )
              n.push("translate3d(0px, 0px, 0px)");
            return n;
          })(),
          left: (function () {
            for (
              var n = [], t = 0;
              t < m(kt().sectionSelector, xt()).length;
              t++
            )
              n.push(0);
            return n;
          })(),
          options: kt(),
          setAutoScrolling: null,
        })),
        (s.shared = Object.assign(s.shared, { nt: null, Qn: !1 })),
        (r.fullpage_api = s),
        xt() && (hn.R(Mn), Jo(), hn.R(An)),
        gn({ an: !0 }),
        r.fullpage_api
      );
    Zo();
  }
  return (
    hn.D(xn, function () {
      clearTimeout(Ho), clearTimeout(Wo);
    }),
    hn.D(An, function () {
      G("scroll", Uo),
        a.body.addEventListener("scroll", Uo),
        hn.D(jn, function (n) {
          to(n.Xn, n.slideAnchor);
        }),
        hn.D(Dn, function (n) {
          eo(n.anchor, void 0);
        }),
        hn.D(On, function (n) {
          ("down" === n.direction ? Li : Di)();
        }),
        hn.D(En, function (n) {
          Fe(n.destination);
        });
    }),
    hn.D(xn, function () {
      Y("scroll", Uo);
    }),
    (s.getActiveSlide = function () {
      return ne(mn().I.activeSlide);
    }),
    (s.getScrollX = function () {
      return pn.scrollX;
    }),
    hn.D(An, function () {
      hn.D(xn, Je),
        hn.D(Rn, function (n) {
          Qe(n.slides, n.destination);
        }),
        hn.D(Sn, function (n) {
          Ji(n.section);
        }),
        hn.D(yn, function (n) {
          Qi(n.section);
        }),
        hn.D(In, _o);
    }),
    hn.D(An, function () {
      var n = kt().credits.position || "right",
        t = ["left", "right"].indexOf(n) > -1 ? "".concat(n, ": 0;") : "",
        e = '\n        <div class="fp-watermark" style="'
          .concat(
            t,
            '">\n            <a href="https://alvarotrigo.com/fullPage/" \n                rel="nofollow noopener" \n                target="_blank" \n                style="text-decoration:none; color: #000;">\n                    '
          )
          .concat(
            kt().credits.label || "Made with fullPage.js",
            "\n            </a>\n        </div>\n    "
          ),
        i = un(pn.C),
        o = !pn.Zn || kt().credits.enabled;
      i && i.item && o && i.item.insertAdjacentHTML("beforeend", e);
    }),
    (function () {
      hn.D(Tn, function () {
        var t, u, l;
        gn({
          Zn:
            (kt().licenseKey,
            (t = kt().licenseKey),
            (u = (function (t) {
              var e = parseInt("514").toString(16);
              if (!t || t.length < 29 || 4 === t.split(n[0]).length)
                return null;
              var i = ["Each", "for"][o()]().join(""),
                u = t[["split"]]("-"),
                l = [];
              u[i](function (n, t) {
                if (t < 4) {
                  var i = (function (n) {
                    var t = n[n.length - 1],
                      e = ["NaN", "is"][o()]().join("");
                    return window[e](t)
                      ? r(t)
                      : (function (n) {
                          return n - Yn.length;
                        })(t);
                  })(n);
                  l.push(i);
                  var a = r(n[i]);
                  if (1 === t) {
                    var u = ["pa", "dS", "t", "art"].join("");
                    a = a.toString()[u](2, "0");
                  }
                  (e += a), (0 !== t && 1 !== t) || (e += "-");
                }
              });
              var c = 0,
                f = "";
              return (
                t.split("-").forEach(function (n, t) {
                  if (t < 4) {
                    for (var e = 0, i = 0; i < 4; i++)
                      i !== l[t] &&
                        ((e += Math.abs(r(n[i]))), isNaN(n[i]) || c++);
                    var o = a(e);
                    f += o;
                  }
                }),
                (f += a(c)),
                {
                  tt: new Date(e + "T00:00"),
                  et: e.split("-")[2] === 8 * (Yn.length - 2) + "",
                  it: f,
                }
              );
            })(t)),
            (l =
              (function (n) {
                var t = i[o()]().join("");
                return n && 0 === t.indexOf(n) && n.length === t.length;
              })(t) ||
              (function (n) {
                return new RegExp(
                  "^(?=.*?[A-Y])(?=.*?[a-y])(?=.*?[0-8])(?=.*?[#?!@$%^&*-]).{8,}$"
                ).test(n);
              })(t)),
            ((u || l) &&
              ((u && e <= u.tt && u.it === t.split(n[0])[4]) || l || u.et)) ||
              !1),
        });
      });
      var n = ["-"],
        t = "2025-0-27".split("-"),
        e = new Date(t[0], t[1], t[2]),
        i = ["se", "licen", "-", "v3", "l", "gp"];
      function o() {
        return [["re", "verse"].join("")]["".length];
      }
      function r(n) {
        return n ? (isNaN(n) ? n.charCodeAt(0) - 72 : n) : "";
      }
      function a(n) {
        var t = 72 + n;
        return (
          t > 90 && t < 97 && (t += 15), String.fromCharCode(t).toUpperCase()
        );
      }
    })(),
    hn.D(Fn, Ko),
    hn.D(In, qo),
    hn.D(zn, Ko),
    hn.D(Nn, qo),
    hn.D(Mn, function () {
      Go(!0);
    }),
    (s.setKeyboardScrolling = Go),
    (s.shared.nt = Yo),
    (s.setAllowScrolling = Xo),
    (s.destroy = function (n) {
      ye(!1, "internal"),
        Xo(!0),
        wo(!1),
        Go(!1),
        E(xt(), Gn),
        hn.R(xn),
        n &&
          (qt(0),
          m(
            "img[data-src], source[data-src], audio[data-src], iframe[data-src]",
            xt()
          ).forEach(function (n) {
            cn(n, "src");
          }),
          m("img[data-srcset]").forEach(function (n) {
            cn(n, "srcset");
          }),
          tn(m("#fp-nav, .fp-slidesNav, .fp-controlArrow")),
          T(Rt(mn().C), { height: "", "background-color": "", padding: "" }),
          T(Rt(mn().slides), { width: "" }),
          T(xt(), {
            height: "",
            position: "",
            "-ms-touch-action": "",
            "touch-action": "",
          }),
          T(Qt, { overflow: "", height: "" }),
          R(Xt, $n),
          R(Yt, Kn + " " + _n),
          Yt.className.split(/\s+/).forEach(function (n) {
            0 === n.indexOf("fp-viewing") && R(Yt, n);
          }),
          Rt(mn().dn).forEach(function (n) {
            kt().scrollOverflow && Ye.In(n),
              R(n, "fp-table active fp-completely " + vt);
            var t = K(n, "data-fp-styles");
            t && n.setAttribute("style", t),
              b(n, Jn) && !Tt && n.removeAttribute("data-anchor");
          }),
          Ut(xt()),
          [nt, lt, at].forEach(function (n) {
            m(n, xt()).forEach(function (n) {
              I(n);
            });
          }),
          T(xt(), { "-webkit-transition": "none", transition: "none" }),
          R(xt(), Vn),
          r.scrollTo(0, 0),
          [Jn, et, ut].forEach(function (n) {
            R(m("." + n), n);
          }));
    }),
    (r.fp_easings = w(r.fp_easings, {
      easeInOutCubic: function (n, t, e, i) {
        return (n /= i / 2) < 1
          ? (e / 2) * n * n * n + t
          : (e / 2) * ((n -= 2) * n * n + 2) + t;
      },
    })),
    r.jQuery &&
      (function (n, t) {
        n && t
          ? (n.fn.fullpage = function (e) {
              (e = n.extend({}, e, { $: n })),
                new t(this[0], e),
                Object.keys(s).forEach(function (n) {
                  kt().$.fn.fullpage[n] = s[n];
                });
            })
          : h(
              "error",
              "jQuery is required to use the jQuery fullpage adapter!"
            );
      })(r.jQuery, nr),
    nr
  );
});
